<template>
    <div class="row">
        <div class="col-12 mt-3">
            <div class="row">
                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.current_password')}}
                </div>
                <div class="col-7 mt-3">
                    <input :type="passwordType" @keyup.enter="saveAction" maxlength="50" class="form-control" v-model="model.current_password">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.new_password')}}
                </div>
                <div class="col-7 mt-3">
                    <input :type="passwordType" @keyup.enter="saveAction" maxlength="50" class="form-control" v-model="model.new_password">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.confirm_new_password')}}
                </div>
                <div class="col-7 mt-3">
                    <input :type="passwordType" @keyup.enter="saveAction" maxlength="50" class="form-control" v-model="model.confirm_new_password">
                </div>

                <div class="col-5 text-right mt-3">
                    <button type="submit" :disabled="this.$store.state.ajax_in_progress" class="btn btn-dark mt-2" @click="togglePasswords">
                        <i :class="passwordType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" aria-hidden="true"></i> {{ buttonText }}
                    </button>
                </div>

                <div class="col-7 mt-3">
                    <button type="submit" :disabled="this.$store.state.ajax_in_progress" class="btn btn-success mt-2 float-right" @click="saveAction">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('misc.save_password')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';

export default {
    name: 'profile_change_password',
    components: {
        miniToastr
    },
    data() {
        return {
            passwordType: 'password',
            buttonText: Vue.i18n.translate('misc.show_passwords'),
            model: {
                current_password: null,
                new_password: null,
                confirm_new_password: null
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        saveAction () {
            let credentials = {
                id:                   this.$store.state.user.user.id,
                current_password:     this.model.current_password,
                new_password:         this.model.new_password,
                confirm_new_password: this.model.confirm_new_password,
            };

            Object.keys(credentials).forEach(key => {
                if (credentials[key] === '') {
                    credentials[key] = null;
                }
            });

            this.$store.dispatch('editPassword', credentials).then(response => {
                if (response.isError == true) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.model.current_password = '';
                    this.model.new_password = '';
                    this.model.confirm_new_password = '';
                }
            });
        },
        togglePasswords () {
            if (this.passwordType === 'password') {
                this.passwordType = 'text';
                this.buttonText   = Vue.i18n.translate('misc.hide_passwords');
            } else {
                this.passwordType = 'password';
                this.buttonText   = Vue.i18n.translate('misc.show_passwords');
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/users/profile/profile_change_password.vue